module.exports = __webpack_public_path__ + "prod/1.42.2/img/mixOsBannerMobile.b6f1de6f.png";